import { render, staticRenderFns } from "./AgencyDetailPage.vue?vue&type=template&id=21061b7c&scoped=true&"
import script from "./AgencyDetailPage.vue?vue&type=script&lang=js&"
export * from "./AgencyDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21061b7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21061b7c')) {
      api.createRecord('21061b7c', component.options)
    } else {
      api.reload('21061b7c', component.options)
    }
    module.hot.accept("./AgencyDetailPage.vue?vue&type=template&id=21061b7c&scoped=true&", function () {
      api.rerender('21061b7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/AgencyDetailPage.vue"
export default component.exports